import React, { Component } from 'react'

export default class Ci extends Component {
    render() {
        return (
            <main className="page-main-pal container">
                <div className="alocolumns clearfix">
                    <div className="column main">
                    <div className="product-view">
                        <div className="product-essential">
                        <div className="row">
                            <div className="product media product-img-box clearfix col-md-5 col-sm-5 col-xs-12">
                            <div className="gallery-placeholder _block-content-loading" data-gallery-role="gallery-placeholder">
                                <img alt="main product" className="gallery-placeholder__image" src="https://zollwebstore.com/media//myDevices/images/AED3_1.jpg" />
                            </div>
                            </div>
                            <div className="product-info-main product-shop col-md-7 col-sm-7 col-xs-12">
                            <div className="product-info-price">
                                <div className="page-title-wrapper">
                                    {/* ganti judul product detail */}
                                <h1 className="page-title">
                                    <span className="base" data-ui-id="page-title-wrapper">ZOLL AED 3</span>
                                </h1>
                                </div>
                                <span data-role="amhideprice-hide-button" id="amhideprice-product-id-314-1040" style={{display: 'none !important'}} />
                            </div>
                            <div className="product attribute overview">
                                {/* ganti product description product detail */}
                                <div className="value" itemProp="description">
                                    <p>ZOLL AED 3 for medical rescuers</p>
                                    <p>
                                        Dalam situasi henti jantung mendadak, tindakan cepat dan tepat sangat penting untuk menyelamatkan nyawa. Zoll AED 3 hadir dengan teknologi canggih untuk memberikan panduan real-time yang membantu penolong melakukan CPR dengan efektif.
                                    </p>
                                    <h2> <strong>Fitur ZOLL AED 3</strong></h2>
                                    <ul>
                                        <li>
                                            Panduan Real CPR Help
                                        </li>
                                        <li>
                                            Rapid Shock Analysis
                                        </li>
                                        <li>
                                            CPR Uni-Padz Elektroda
                                        </li>
                                        <li>
                                            Konektivitas Cloud
                                        </li>
                                        <li>
                                            Daya Tahan Baterai dan Elektroda
                                        </li>
                                        <li>
                                            Tersedia dalam mode fully-automated dan semi-automated
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>    
                    </div>
                </div>
            </main>
        )
    }
}
